/**
 * DailyRoll — LOCKED CONTRACT: simulation & protocol constants.
 *
 * These numbers are part of the determinism contract. Changing TICK_RATE,
 * FIXED_DT, STEER_QUANT, or any *_VERSION below is a BREAKING change: replays
 * recorded under the old values can no longer be re-simulated by the Worker.
 * Bump SIM_VERSION whenever physics, course generation, or these values change.
 *
 * Owned by: Architect. Consumed by all four agents (Core, Render, Shell, Backend).
 */

/** Wire format of ScoreSubmission and the HTTP API. Bump on API shape changes. */
export const PROTOCOL_VERSION = 1;

/** Deterministic physics + course-generation version. Server refuses to verify
 *  a replay whose simVersion differs from its own. Bump on ANY sim change. */
export const SIM_VERSION = 1;

/** Shape version of CourseSpec / GameState / ReplayData payloads. */
export const SCHEMA_VERSION = 1;

/** Fixed simulation rate. The sim NEVER steps at the render frame rate. */
export const TICK_RATE = 60;
/** Seconds per fixed tick. */
export const FIXED_DT = 1 / TICK_RATE;
/** Milliseconds per fixed tick. */
export const FIXED_DT_MS = 1000 / TICK_RATE;

/** Hard run cap. A run that has not finished by this tick is scored as DNF. */
export const MAX_RUN_TICKS = 90 * TICK_RATE; // 90 seconds

/** Steer components are quantized to signed-16-bit before they enter a replay,
 *  so the recorded input is bit-exact across JSON round-trips and platforms.
 *  Raw steer in [-1, 1] maps to integer [-STEER_QUANT, STEER_QUANT]. */
export const STEER_QUANT = 32767;
